/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Marker
 */
export interface Marker {
    /**
     * 
     * @type {number}
     * @memberof Marker
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Marker
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Marker
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof Marker
     */
    tIn: number;
    /**
     * 
     * @type {number}
     * @memberof Marker
     */
    tOut: number;
    /**
     * 
     * @type {Date}
     * @memberof Marker
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Marker
     */
    readonly modifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Marker
     */
    readonly user?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Marker
     */
    asset: number;
    /**
     * 
     * @type {number}
     * @memberof Marker
     */
    readonly comment?: number | null;
}

export function MarkerFromJSON(json: any): Marker {
    return MarkerFromJSONTyped(json, false);
}

export function MarkerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Marker {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'tIn': json['t_in'],
        'tOut': json['t_out'],
        'createdAt': (new Date(json['created_at'])),
        'modifiedAt': (new Date(json['modified_at'])),
        'user': !exists(json, 'user') ? undefined : json['user'],
        'asset': json['asset'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function MarkerToJSON(value?: Marker | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'text': value.text,
        't_in': value.tIn,
        't_out': value.tOut,
        'asset': value.asset,
    };
}


